import type React from "react";
import { Button, Badge } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import type { ResourceType } from "@/shared/work-orders-modals/components/work-order-resources/table-work-ordes-resoures";
import FolderIcon from "@mui/icons-material/Folder";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
	folderIcon: {
		color: "#FFC107",
	},
});

interface Props {
	params: any;
	setSelectedRow: Function;
	openResourceModal: (resource: ResourceType, rowData: any) => void;
}

export const WorkOrdersResourcesColumn: React.FC<Props> = ({
	params,
	setSelectedRow,
	openResourceModal,
}) => {
	const classes = useStyles();
	const handleClick = () => {
		setSelectedRow(params.data);
		openResourceModal("DRAWINGS", params.data);
	};

	const resourceCount = params.data?.ResourcesCount || 0;

	return (
		<Grid2
			container
			spacing={1}
			style={{ justifyContent: "flex-end", minWidth: 30 }}
		>
			<Grid2 size={{ xs: 12, md: 12 }}>
				<Button fullWidth style={{}} onClick={handleClick}>
					<Badge
						badgeContent={resourceCount}
						color="primary"
						style={{ transform: "scale(0.8)" }}
					>
						<FolderIcon
							className={classes.folderIcon}
							style={{ height: "auto", marginTop: "-2px" }}
						/>
					</Badge>
				</Button>
			</Grid2>
		</Grid2>
	);
};
